// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import linkExternal01Icon from "@/assets/icons/link-external-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type LinkExternal01IconProps = Omit<IconProps, "name">;

export function LinkExternal01Icon(props: LinkExternal01IconProps): React.ReactNode {
  return <Icon name={linkExternal01Icon} {...props} />;
}
